/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Pos_To_ConfirmInputs */

const en_queue_pos_to_confirm = /** @type {(inputs: Queue_Pos_To_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase orders to be confirmed`)
};

/**
* | output |
* | --- |
* | "Purchase orders to be confirmed" |
*
* @param {Queue_Pos_To_ConfirmInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_pos_to_confirm = /** @type {((inputs?: Queue_Pos_To_ConfirmInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Pos_To_ConfirmInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_pos_to_confirm(inputs)
});